import { User } from "@/interfaces";
import api from "@/lib/axios";
import type { LoginResponse } from "./types";

export const authService = {
  async login(login: string, password: string) {
    const response = await api.post<LoginResponse>("/login", {
      login,
      password,
    });
    return response.data;
  },

  async logout() {
    await api.post("/auth/logout");
  },

  async getProfile() {
    const response = await api.get<User>("/auth/me");
    return response.data;
  },

  async forgotPassword(email: string) {
    await api.post("/forgot_password", { email });
  },

  async resetPassword(payload: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
  }) {
    await api.post("/reset_password", payload);
  },
};
